<div class="customerImprovement">
  <div class="customerImprovement__content">
    <div class="headline">
      <span class="tipp">Tipp</span>
      <strong class="suggestion">Bonität verbessern</strong>
    </div>
    <div class="subtext">
      Wir haben hilfreiche Tipps für Sie zusammengefasst.
      <a href="https://www.check24.de/kredit/bonitaet/" target="_blank">Zu den Tipps</a>
    </div>
  </div>
  <div class="customerImprovement__content">
    <div class="headline">
      <span class="tipp">Tipp</span>
      <strong class="suggestion">Zweiten Kreditnehmer hinzufügen</strong>
    </div>
    <div class="subtext">
      Ein zweiter Kreditnehmer (z.B. Lebenspartner, Verwandter) mit Einkommen und positiver Schufa erhöht
      die Chance auf attraktive Kreditangebote.
    </div>
    <button class="content__button"
            styleClass="button-primary">
      zweiten Kreditnehmer hinzufügen
    </button>
  </div>
  <div *ngIf="false" class="customerImprovement__content">
    <div class="headline">
      <span class="tipp">Tipp</span>
      <strong class="suggestion">Anfrage anpassen</strong>
    </div>
    <div class="subtext">
      Eine geringere Kreditsumme oder längere Laufzeit erhöht die Chance auf Angebote.
    </div>
  </div>
  <div class="customerImprovement__content" *ngIf="false">
    <div class="headline">
      <span class="tipp">Tipp</span>
      <div class="suggestion">
        Um mehr Angebote zu erhalten,
        <span>
          probieren Sie mit einem zweiten Kreditnehmer anzufragen
        </span>
      </div>
    </div>
  </div>
</div>
